import React from 'react';
import '../App.css';
import ChangePassword from './ChangePassword/ChangePassword';

function Account() {
  return (
    <div>
      <ChangePassword />
    </div>
  );
}

export default Account;
